import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import StoreIcon from "@mui/icons-material/Store";
import { formatCurrency2Digit } from "utils/helpers/format";

const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpen,
  handleModalOpenMarketplace
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const columns = [
    {
      Header: "",
      accessor: "checkbox",
      width: "50px",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Checkbox
          checked={selected[row.values.id] || false}
          onChange={() => handleCheckboxChange(row.values.id)}
        />
      ),
    },
    {
      Header: "",
      accessor: "expand",
      width: "100px",
      disableSortBy: true,
      Cell: ({ row }) =>
        row.values.actions ? (
          <IconButton onClick={() => row.toggleRowExpanded()}>
            <ExpandMoreIcon />
          </IconButton>
        ) : null,
    },
    {
      Header: "รูปภาพ",
      accessor: "picture",
      disableSortBy: true,
      showInFilter: false,
    },
    { Header: "รหัสสินค้า", accessor: "product_code", showInFilter: true },
    { Header: "ชื่อสินค้า", accessor: "product_name", showInFilter: true },
    {
      Header: "จำนวนคงเหลือ",
      accessor: "remaining_amount",
      showInFilter: false,
    },
    {
      Header: "ราคาทุน/ชิ้น",
      accessor: "price",
      showInFilter: true,
      Cell: ({ row }) => {
        return <span>{formatCurrency2Digit(row.price || 0)}</span>;
      },
    },
    { Header: "วันที่ซื้อเข้า", accessor: "created_date", showInFilter: true },
    { Header: "ประเภท", accessor: "product_type", showInFilter: false },
    { Header: "Marketplace", accessor: "market_status", showInFilter: false },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div>
          <IconButton onClick={(event) => handleMenuOpen(event, row.id)}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && activeRowId === row.id}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => {
                console.log("row ข้อมูลอยู่นี่", row);
                setViewProduct(row);
                handleViewOpen();
                handleMenuClose();
              }}
            >
              <RemoveRedEyeIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />

              <span style={{ marginLeft: "8px", color: "#737373" }}>
                ดูรายละเอียด
              </span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                // console.log("row", row);
                setProduct(row);
                handleModalOpen();
                handleMenuClose();
              }}
            >
              <ShoppingCartIcon
                style={{ marginRight: "8px", color: "#737373" }}
              />
              <span style={{ marginLeft: "8px", color: "#737373" }}>ขาย</span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                // console.log("row", row);
                setProduct(row);
                handleModalOpenMarketplace();
                handleMenuClose();
              }}
            >
              <StoreIcon style={{ marginRight: "8px", color: "#737373" }} />
              <span style={{ marginLeft: "8px", color: "#737373" }}>
                Marketplace
              </span>
            </MenuItem>
          </Menu>
        </div>
      ),
    },
  ];

  return columns;
};

export default useColumns;
